import {IDataObject} from '@/util/IDataObject';
import {Util} from '@/util/Util';

export class User implements IDataObject<User> {

    public name: string = '';

    public password: string = '';

    public userId: number = -1;

    public fromObject(source: any): User {
        Util.deepCopy(source, this);
        return this;
    }

    public getCopy(): object {
        return {
            name: this.name,
            userId: this.userId,
            password: this.password,
        };
    }

}
